<template>
    <div class="footer-warpper">Copyright 2022 ©北京消防协会会员信息系统 All rights reserved.
        <a href="http://beian.miit.gov.cn" target="_blank">京ICP备15022697号-1</a>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502040396"
           target="_blank">
            <img alt="" src="http://www.beian.gov.cn/img/new/gongan.png">京公网安备11010502040396号
        </a>
    </div>

</template>

<script>
export default {
    name: "footer-modular",
}
</script>

<style lang="scss" scoped>
.footer-warpper {
    height: 40px;
    line-height: 40px;
    text-align: left;
    padding-left: 30px;
    color: #808080;
    font-size: 12px;
    img {
        width: 15px;
        height: 15px;
        margin: 0 5px;
    }

    a {
        font-size: 12px;
        color: #808080;
    }
}
</style>